{
  "levelCap": 10,
  "xpPerLevel": [0, 200, 450, 750, 1100, 1500, 1950, 2450, 3000, 3600],
  "startMoney": 350,
  "startAmmo": { "pistol": 48, "heavy": 0, "smart": 0, "762r": 0, "12ga": 0 },
  "xp": { "takedown_gang": 25, "takedown_police": 30, "takedown_drone": 30, "takedown_elite": 80, "escape_per_star": 40, "hack": 5 },
  "credUnlocks": { "hardChallenges": 15, "tail": 10, "billboard": 20, "repo": 30, "getaway": 40, "tower": 50 }
}
